import { useEffect, useState, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { I18nContext } from '../context/I18nProvider'
import { useTranslation } from 'react-i18next'

/*
    Este hook lee la url de itinerarios y actualiza el contexto de opciones seleccionadas de ItinerariesProvider
    De estas opciones se alimentaran los componentes  "DestinationSearch" y "DestinationFilter".
*/

const useContextSelectedOptions = () => {
    const location = useLocation()
    const { t } = useTranslation()
    const { language } = useContext(I18nContext)

    //OPCIONES SELECCIONADAS
    const [contextSelectedOptions, setContextSelectedOptions] = useState({
        destination: '',
        type_of_experience: '',
        type_of_travel: '',
    })

    //Este efecto escucha cambios en la url solo dentro de la pagina de itinerarios y actualiza el contexto de opciones seleccionadas
    useEffect(() => {
        //Analizamos solo cuando estemos en la pagina de itinerarios
        if (location.pathname === `/${language}${t('routes.itineraries')}`) {
            //Si hay search entonces seteamos las opciones seleccionadas
            if (location.search) {
                const params = new URLSearchParams(location.search)

                const objectParams = {
                    destination: '',
                    type_of_experience: '',
                    type_of_travel: '',
                }

                params.forEach((value, key) => {
                    // Antes se hacia solo con esta linea de abajo pero se rompe con los textos que usan & ej "Deserts & Valleys"
                    objectParams[key] = value
                })

                setContextSelectedOptions(objectParams)
            } else {
                //Si no hay search reseteamos las opciones seleccionadas
                setContextSelectedOptions({
                    destination: '',
                    type_of_experience: '',
                    type_of_travel: '',
                })
            }
        }
    }, [location])

    return [contextSelectedOptions, setContextSelectedOptions]
}

export default useContextSelectedOptions
